function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { isProd } from "../../utils/env";
/**
 * This can be used to wrap any value that is not a design token from the theme,
 * and it will bypass validation. This allows for one of designs to be implemented,
 * while at the same time, make it explicit that the values are not standard and
 * make it easy to search for
 */

export var RAW_cssValue = function RAW_cssValue(val) {
  if (isProd) {
    return val;
  } else {
    return new __CssValueClass(val);
  }
};
export var __CssValueClass = function __CssValueClass(val) {
  _classCallCheck(this, __CssValueClass);

  this.val = val;
};
//# sourceMappingURL=RAW_cssValue.js.map